export function loginUI() {
    document.querySelector(".cp-bulletin-board-settings").innerHTML = `
                <p style="margin-top: 0;">Please login before continuing.</p>
                <p style="margin-top: 64px;">
                    <a href="/members/bulletin-board-login" class="cp__btn">Login</a>
                </p>
            `;
}
